import React from 'react';
import { photographerUrl, UNSPLASH_HOME } from '../../utils/unsplashCredit';

/**
 * The credit, rendered. Not just the URLs.
 *
 * Centralising `photographerUrl` alone left every surface free to spell the
 * credit differently, and they did: the hero said "Photo by X" with only the
 * photographer linked, a day band said "Photo: X / Unsplash", and the mobile
 * one was not a link at all. Unsplash grants production rate limits against a
 * checklist that names the wording AND the links, and the reviewer reads
 * screenshots — so the rendering is the compliance surface, and it belongs in
 * one place.
 */
export function UnsplashCredit(
  { photographer, profileLink, className }:
  { photographer: string; profileLink?: string; className?: string },
) {
  if (!photographer) return null;
  return (
    <span className={className}>
      Photo by{' '}
      <a
        href={photographerUrl(profileLink || '')}
        target="_blank"
        rel="noopener noreferrer nofollow"
      >
        {photographer}
      </a>{' '}
      on{' '}
      <a href={UNSPLASH_HOME} target="_blank" rel="noopener noreferrer nofollow">
        Unsplash
      </a>
    </span>
  );
}
